import React, { Fragment, useState, useEffect } from 'react';

import './Resources/css/site_fonts.css';
import './Resources/css/site.css';
import './Resources/css/site_navbar.css';
import Common from '../../Shared/Common';

import AppWrapper from '../../Controls/Scafolding/AppWrapper';
import { NavMenu } from '../../Controls/NavMenu';

import Top from './Blocks/Top';
import AboutUs from './Blocks/AboutUs';
import ImageInsert from '../../Controls/Digital/ImageInsert';
import TheSecret from './Blocks/TheSecret';
import Produce from './Blocks/Produce';
import ContactUs from './Blocks/ContactUs';
import Catering from './Blocks/Catering';
import Footer from './Blocks/Footer';

const Bakery = (props) => {

    let logoIconPath = require("./Resources/Images/Logo-sample-4.png");

    const [menu] = useState({
        hasLogo: true,
        logoUrl: logoIconPath,
        styles: {},

        text: 'Gwynneville Bakery',
        textSmallDisplay: 'Gwynneville Bakery',
        icon: "",

        hasMessage : true,
        messageLeft : '',
        messageMiddle: '168 Gipps Rd - Gwynneville NSW 2500',
        middle2ndLine: 'Mon - Fri: 9am - 5pm',
        middle3rdLine: 'Sat: 10am - 16pm',
        middle4hLine: 'Sun: CLOSED',

        items: [
            { linkLabel: 'Home', linkUrl: '#top' },
            { linkLabel: 'Our Story', linkUrl: '#aboutUs' },
            { linkLabel: 'The Baker', linkUrl: '#theSecret' },
            { linkLabel: 'Catering', linkUrl: '#catering' },
            { linkLabel: 'Contact', linkUrl: '#contactUs' },
        ]
    });

    useEffect(() => {
    });

    return (
        <AppWrapper wrapClass="gbk">
            <NavMenu menu={menu} offset="50" addClass="Menu sticky-top" />

            <Top />
            <AboutUs />

            <ImageInsert addClass="insert1" />

            <TheSecret />
            <Catering />

            <ImageInsert addClass="insert2" />

            <ContactUs />

            <Footer />
        </AppWrapper>
    );
}
export default Bakery;

